import DniValidator from '../utils/DniValidator.js';

class FormValidator {
    constructor() {
        this.dniValidator = DniValidator;
    }

    validate(formData, showErrors = true) {
        const rules = {
            nombre: { required: true, minLength: 2 },
            apellidos: { required: true, minLength: 2 },
            email: { required: true, email: true },
            telefono: { required: true, phone: true },
            superficie: { required: true, numeric: true, min: 1 },
            // referencia_catastral: { required: false, minLength: 20, maxLength: 20 },
            provincia: { required: true },
            municipio: { required: true },
            codigo_postal: { required: true, numeric: true, minLength: 5, maxLength: 5 },
            // dir_tipo_via: { required: true },
            dir_nombre_via: { required: true },
            dir_numero: { required: true, minLength: 1, maxLength: 10 },
        };

        if (showErrors) {
            // Limpiar errores anteriores
            this.clearErrorHighlights(formData);
        }

        const errors = [];
        // Iterate through all form fields first
        for (const pair of formData.entries()) {
            const field = pair[0];
            const value = pair[1];
            
            // Check if field has validation rules
            if (rules.hasOwnProperty(field)) {
                const fieldErrors = this.validateField(field, value, rules[field], formData);
                errors.push(...fieldErrors);
            }
        }

        if (errors.length > 0) {
            if (showErrors) {
                this.showValidationErrors(errors);
            }
            return errors;
        }
        // CASO ESPECIAL, SE DEVUELVEN LOS ERRORES O SI NO HAY UN ARRAY VACÍO
        return [];
    }

    validateAddress(formData) {
        const rules = {
            dir_tipo_via: { required: true },
            dir_nombre_via: { required: true },
            dir_numero: { required: true },
            codigo_postal: { required: true },
            provincia: { required: true },
            municipio: { required: true }
        };

        // Limpiar errores anteriores
        this.clearErrorHighlights(formData);
        const errors = [];
        
        for (const pair of formData.entries()) {
            const field = pair[0];
            const value = pair[1];
            
            // Check if field has validation rules
            if (rules.hasOwnProperty(field)) {
                const fieldErrors = this.validateField(field, value, rules[field], formData);
                errors.push(...fieldErrors);
            }
        }

        if (errors.length > 0) {
            this.showValidationErrors(errors);
            return errors;
        }

        return [];
    }

    validateStep2(formData, showErrors = true) {
        const rules = {
            tipo_operacion: { required: true },
            destino: { required: true },
            finalidad: { required: true },
            estado_inmueble: { required: true },
        };

        if (showErrors) {
            // Limpiar errores anteriores
            this.clearErrorHighlights(formData);
        }

        const errors = [];
        // Iterate through all form fields first
        for (const pair of formData.entries()) {
            const field = pair[0];
            const value = pair[1];
            
            // Check if field has validation rules
            if (rules.hasOwnProperty(field)) {
                const fieldErrors = this.validateField(field, value, rules[field], formData);
                errors.push(...fieldErrors);
            }
        }

        if (errors.length > 0) {
            if (showErrors) {
                this.showValidationErrors(errors);
            }
            return errors;
        }
        // CASO ESPECIAL, SE DEVUELVEN LOS ERRORES O SI NO HAY UN ARRAY VACÍO
        return [];
    }

    validateStep3(formData, showErrors = true) {
        const rules = {
            nota_simple: { required: false, requiredIf: 'tiene_nota_simple', requiredIfValue: 'si' },
            cee: { required: false, requiredIf: 'tiene_cee', requiredIfValue: 'si' },
            nota_simple_garaje: { required: false, requiredIf: ['anadir_garaje', 'tiene_nota_simple_garaje'], requiredIfValue: ['1', 'si'] },
            cee_garaje: { required: false, requiredIf: ['anadir_garaje', 'tiene_cee_garaje'], requiredIfValue: ['1', 'si'] },
            nota_simple_trastero: { required: false, requiredIf: ['anadir_trastero', 'tiene_nota_simple_trastero'], requiredIfValue: ['1', 'si'] },
            cee_trastero: { required: false, requiredIf: ['anadir_trastero', 'tiene_cee_trastero'], requiredIfValue: ['1', 'si'] },
        };

        if (showErrors) {
            // Limpiar errores anteriores
            this.clearErrorHighlights(formData);
        }

        const errors = [];
        // Iterate through all form fields first
        for (const pair of formData.entries()) {
            const field = pair[0];
            const value = pair[1];
            
            // Check if field has validation rules
            if (rules.hasOwnProperty(field)) {
                const fieldErrors = this.validateField(field, value, rules[field], formData);
                errors.push(...fieldErrors);
            }
        }

        if (errors.length > 0) {
            if (showErrors) {
                this.showValidationErrors(errors);
            }
            return errors;
        }
        // CASO ESPECIAL, SE DEVUELVEN LOS ERRORES O SI NO HAY UN ARRAY VACÍO
        return [];
    }

    validateStep4(formData, showErrors = true) {
        const rules = {
            contacto_nombre_completo: { required: false, requiredIf: 'mismo_contacto', requiredIfValue: '0' },
            contacto_telefono: { required: false, phone: true, requiredIf: 'mismo_contacto', requiredIfValue: '0' },
        };

        if (showErrors) {
            // Limpiar errores anteriores
            this.clearErrorHighlights(formData);
        }

        const errors = [];
        
        for (const pair of formData.entries()) {
            const field = pair[0];
            const value = pair[1];
            
            // Check if field has validation rules
            if (rules.hasOwnProperty(field)) {
                const fieldErrors = this.validateField(field, value, rules[field], formData);
                errors.push(...fieldErrors);
            }
        }

        if (errors.length > 0) {
            if (showErrors) {
                this.showValidationErrors(errors);
            }
            return errors;
        }

        return [];
    }

    validateCheckout(formData) {
        const rules = {
            requester_nif_type: { required: true },
            requester_nif: { required: true, nif: true },
            billing_first_name: { required: true, minLength: 2 },
            billing_last_name: { required: true, minLength: 2 },
            billing_email: { required: true, email: true },
            billing_phone: { required: true, phone: true },
            billing_nif_type: { required: true },
            billing_nif: { required: false, nif: true, requiredIf: 'is_company', requiredIfValue: '' }, // DNI, CIF o NIE valid
            is_company: { required: false },
            billing_cif_type: { required: true },
            billing_cif: { required: false, cif: true, requiredIf: 'is_company', requiredIfValue: '1' },
            billing_company: { required: false, requiredIf: 'is_company', requiredIfValue: '1' },
            billing_address_1: { required: true },
            billing_city: { required: true },
            billing_postcode: { required: true },
            billing_state: { required: true },
            billing_country: { required: true },
            legal_terms_privacy: { required: true },
        };

        // Limpiar errores anteriores
        this.clearErrorHighlights(formData);
        const errors = [];

        console.log("Validando FORM DATA", formData);

        // Validar campos básicos
        for (const pair of formData.entries()) {
            const field = pair[0];
            const value = pair[1];

            // Si el campo es NIF o CIF añadir las reglas correspondientes
            if (field == 'requester_nif') {
                const type = formData.get('requester_nif_type') ?? 'otro';
                rules[field].doc_type = type ?? '';
            }
            if (field == 'billing_nif') {
                const type = formData.get('billing_nif_type') ?? 'otro';
                rules[field].doc_type = type ?? '';
            }
            if (field == 'billing_cif') {
                const type = formData.get('billing_cif_type') ?? 'otro';
                rules[field].doc_type = type ?? '';
            }
            
            if (rules.hasOwnProperty(field)) {
                const fieldErrors = this.validateField(field, value, rules[field], formData);
                errors.push(...fieldErrors);
            }
        }

        console.log('Validando checkout', errors);

        // Validar donación si está presente
        const donationAmount = formData.get('donation_amount');
        if (donationAmount && donationAmount.trim() !== '') {
            const amount = parseFloat(donationAmount);
            if (isNaN(amount) || amount < 0) {
                errors.push({
                    field: 'donation_amount',
                    message: 'El importe de donación debe ser un número válido'
                });
            } else if (amount > 0 && amount < 1) {
                errors.push({
                    field: 'donation_amount',
                    message: 'El importe mínimo de donación es 1€'
                });
            }
        }

        if (errors.length > 0) {
            this.showValidationErrors(errors);
            return errors;
        }

        return [];
    }


    validateField(fieldName, value, rules, formData) {
        const errors = [];
        
        if (rules.required && (!value || value.trim() === '')) {
            // errors.push({field: fieldName, message: `${this.getFieldDisplayName(fieldName)} es obligatorio`});
            errors.push({field: fieldName, message: `Este campo es obligatorio`});
        }

        // Revisar si es requerido por el estado de otro campo
        let isRequired = rules.requiredIf !== undefined;
        let isRequiredValid = true;
        if (isRequired) {
            if (Array.isArray(rules.requiredIf)) {
                // Si todas las condiciones se cumplen el campo es requerido
                // En cuanto una ya no se cumpla, salimos estándo OK.
                for (let i = 0; i < rules.requiredIf.length; i++) {
                    const requiredIfField = rules.requiredIf[i];
                    const requiredIfValue = rules.requiredIfValue[i];
                    if (!this.isValidRequiredIfField(requiredIfField, requiredIfValue, formData)) {
                        isRequiredValid = false;
                        break;
                    }
                }
                
            } else {
                const requiredIfField = rules.requiredIf;
                const requiredIfValue = rules.requiredIfValue;
                if (!this.isValidRequiredIfField(requiredIfField, requiredIfValue, formData)) {
                    isRequiredValid = false;
                }
            }

            if (isRequiredValid && (!value || value.trim() === '')) {
                // errors.push({field: fieldName, message: `${this.getFieldDisplayName(fieldName)} es obligatorio`});
                errors.push({field: fieldName, message: `Este campo es obligatorio`});
            }
        }
        
        if (!isRequired || (isRequired && isRequiredValid)) {
        
            // Solo validar si hay valor (para campos opcionales)
            if (value && value.trim() !== '') {
                if (rules.email && !this.isValidEmail(value)) {
                    errors.push({field: fieldName, message: `El formato de email es incorrecto`});
                }
                
                if (rules.minLength && value.length < rules.minLength) {
                    errors.push({field: fieldName, message: `${this.getFieldDisplayName(fieldName)} debe tener al menos ${rules.minLength} caracteres`});
                }

                if (rules.maxLength && value.length > rules.maxLength) {
                    errors.push({field: fieldName, message: `${this.getFieldDisplayName(fieldName)} no puede tener más de ${rules.maxLength} caracteres`});
                }

                if (rules.phone && !this.isValidPhone(value)) {
                    errors.push({field: fieldName, message: `Escribe un número de teléfono válido`});
                }

                if (rules.numeric && !this.isNumeric(value)) {
                    errors.push({field: fieldName, message: `${this.getFieldDisplayName(fieldName)} debe ser un número válido`});
                }

                if (rules.min && parseFloat(value) < rules.min) {
                    errors.push({field: fieldName, message: `${this.getFieldDisplayName(fieldName)} debe ser mayor o igual a ${rules.min}`});
                }

                if (rules.max && parseFloat(value) > rules.max) {
                    errors.push({field: fieldName, message: `${this.getFieldDisplayName(fieldName)} debe ser menor o igual a ${rules.max}`});
                }

                if (rules.nif) {
                    const result = this.isValidNif(value, rules);
                    console.log('Validando NIF', result);
                    if (!result.isValid) {
                       errors.push({field: fieldName, message: result.message});
                   }
                }

                if (rules.cif) {
                    const result = this.isValidCif(value, rules);
                    if (!result.isValid) {
                        errors.push({field: fieldName, message: result.message});
                    }
                }
            }
        }
        
        return errors;
    }

    isValidRequiredIfField(requiredIfField, requiredIfValue, formData) {
        let requiredIfFieldValue = formData.get(requiredIfField);
        if (requiredIfFieldValue === null) {
            if (requiredIfValue === '' || requiredIfValue === '0') {
                return true;
            }
            return false;
        }
        return requiredIfFieldValue === requiredIfValue;
    }

    isValidEmail(email) {
        // Límite total: 254 caracteres (RFC)
        if (email.length > 254) return false;

        // Regex mejorada
        const re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]{1,64}@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

        if (!re.test(email)) return false;

        const [local, domain] = email.split("@");

        // Local-part y domain no deben empezar/terminar en '.'
        if (local.startsWith(".") || local.endsWith(".")) return false;
        if (domain.startsWith(".") || domain.endsWith(".")) return false;

        // El dominio debe tener al menos un punto y un TLD de 2 a 63 letras
        const parts = domain.split(".");
        if (parts.length < 2) return false;
        const tld = parts[parts.length - 1];
        if (!/^[a-z]{2,63}$/i.test(tld)) return false;

        return true;
    }

    isValidPhone(phone) {
        // Verificar que el teléfono no esté vacío
        if (!phone || phone.trim() === '') return false;
        
        // Limpiar el teléfono de espacios, guiones, paréntesis y puntos
        let cleanPhone = phone.replace(/[\s\-\(\)\.]/g, '');
        
        // Verificar si empieza con + o 00 y procesarlo
        let hasInternationalPrefix = false;
        
        if (cleanPhone.startsWith('+')) {
            hasInternationalPrefix = true;
            cleanPhone = cleanPhone.substring(1); // Quitar el +
        } else if (cleanPhone.startsWith('00')) {
            hasInternationalPrefix = true;
            cleanPhone = cleanPhone.substring(2); // Quitar el 00
        }
        
        // Verificar que solo contenga números después de limpiar
        if (!/^\d+$/.test(cleanPhone)) return false;
        
        // Verificar longitud
        if (hasInternationalPrefix) {
            // Con prefijo internacional: mínimo 7 dígitos (código país + número), máximo 18
            // Ejemplos: +1234567890 (10 dígitos), +34123456789 (11 dígitos)
            if (cleanPhone.length < 7 || cleanPhone.length > 18) return false;
        } else {
            // Sin prefijo internacional: mínimo 7 dígitos, máximo 20
            // Permite números locales o nacionales sin prefijo
            if (cleanPhone.length < 7 || cleanPhone.length > 20) return false;
        }
        
        // Verificar que no empiece con 0 si tiene prefijo internacional
        // (los códigos de país no empiezan con 0)
        if (hasInternationalPrefix && cleanPhone.startsWith('0')) {
            return false;
        }
        
        return true;
    }

    isValidNif(value, rules) {
        if (!value || value.trim() === '') return false;

        console.log("Rules", rules);

        const country = (rules.doc_type ?? '').trim().toLowerCase() == 'otro' ? 'foreign' : 'es';
        if (country == 'es'){
            const result = this.dniValidator.validateDocumentField(value, false);
            return result;
        }
        // No validamos NIF/CIF para otros países
        return {isValid: true, message: ''};
    }

    isValidCif(value, rules) {
        if (!value || value.trim() === '') return false;

        const country = (rules.doc_type ?? '').trim().toLowerCase() == 'otro' ? 'foreign' : 'es';
        if (country == 'es'){
            const result = this.dniValidator.validateDocumentField(value, true);
            return result;
        }
        // No validamos NIF/CIF para otros países
        return {isValid: true, message: ''};
    }

    isNumeric(value) {
        return !isNaN(parseFloat(value)) && isFinite(value);
    }

    getFieldDisplayName(fieldName) {
        const fieldNames = {
            nombre: 'Nombre',
            apellidos: 'Apellidos',
            email: 'Email',
            telefono: 'Teléfono',
            superficie: 'Superficie',
            referencia_catastral: 'Referencia catastral',
            provincia: 'Provincia',
            municipio: 'Municipio',
            dir_numero: 'Número',
            dir_escalera: 'Escalera',
            dir_planta: 'Planta',
            dir_puerta: 'Puerta',
            codigo_postal: 'Código postal',
            dir_nombre_via: 'Nombre de la vía',
            dir_tipo_via: 'Tipo de vía',
            contacto_nombre_completo: 'Nombre del contacto',
            contacto_telefono: 'Teléfono del contacto',
            tipo_operacion: 'Tipo de operación',
            destino: 'Destino',
            finalidad: 'Finalidad',
            estado_inmueble: 'Estado del inmueble',
            nota_simple: 'Nota simple',
            cee: 'CEE',
            nota_simple_garaje: 'Nota simple del garaje',
            cee_garaje: 'CEE del garaje',
            nota_simple_trastero: 'Nota simple del trastero',
            cee_trastero: 'CEE del trastero',
            requester_nif: 'NIF/NIE del solicitante',
            billing_nif: 'NIF/NIE',
            billing_cif: 'CIF',
            billing_company: 'Razón social',
            billing_first_name: 'Nombre',
            billing_last_name: 'Apellidos',
            billing_email: 'Email',
            billing_phone: 'Teléfono',
            billing_address_1: 'Dirección',
            billing_city: 'Ciudad',
            billing_state: 'Provincia',
            billing_postcode: 'Código postal',
            billing_country: 'País',
            legal_terms_privacy: 'Los términos y privacidad de Gesvalt',
        };

        return fieldNames[fieldName] || fieldName;
    }

    showValidationErrors(errors) {
        // Implementación básica - mostrar en consola y alert
        console.log('Errores de validación:', errors);
        
        // Mostrar todos los errores en un <span class="error-messge"> debajo de cada campo
        errors.forEach(error => {
            const field = document.getElementById(error.field) || 
                         document.querySelector(`[name="${error.field}"]`);
            
            if (field) {

                const errorSpan = document.createElement('span');
                errorSpan.className = 'error-label-message';
                errorSpan.textContent = error.message;

                
                if (field.hasAttribute('data-choice') && field.getAttribute('data-choice') === 'active') {
                    
                    // Insertar después del campo
                    field.parentNode.parentNode.parentNode.insertBefore(errorSpan, field.parentNode.parentNode.nextSibling);

                } else {
                    
                    // Insertar después del campo
                    field.parentNode.insertBefore(errorSpan, field.nextSibling);
    
                    this.highlightField(error.field);

                }

            }
        });

    }

    highlightField(fieldName) {
        const field = document.getElementById(fieldName) || 
                     document.querySelector(`[name="${fieldName}"]`);
        
        if (field) {
            field.classList.add('error');
            field.style.borderColor = '#dc3545';
            
            // Remover highlight después de que el usuario interactúe
            const removeHighlight = () => {
                field.classList.remove('error');
                field.style.borderColor = '';
                field.removeEventListener('input', removeHighlight);
                field.removeEventListener('change', removeHighlight);
            };
            
            field.addEventListener('input', removeHighlight);
            field.addEventListener('change', removeHighlight);
        }
    }

    clearErrorHighlights(formData) {
        // Limpia los campos del formData de errores
        formData.forEach((value, key) => {
            const field = document.getElementById(key) || 
                         document.querySelector(`[name="${key}"]`);
            
            if (field) {

                field.classList.remove('error');
                field.style.borderColor = '';

                if (field.hasAttribute('data-choice') && field.getAttribute('data-choice') === 'active') {
                    
                    // Insertar después del campo
                    const errorMessages = field.parentNode.parentNode.parentNode.querySelectorAll('.error-label-message');
                    errorMessages.forEach(message => {
                        message.remove();
                    });

                } else {

                    const errorMessages = field.parentElement.querySelectorAll('.error-label-message');
                    errorMessages.forEach(message => {
                        message.remove();
                    });

                }
            }

        });

    }

    // Método para validar un campo específico en tiempo real
    validateSingleField(fieldName, value, rules) {
        let formData = new FormData();
        formData.append(fieldName, value);
        const errors = this.validateField(fieldName, value, rules, formData);
        
        if (errors.length > 0) {
            this.highlightField(fieldName);
            return false;
        } else {
            // Limpiar highlight si es válido
            const field = document.getElementById(fieldName) || 
                         document.querySelector(`[name="${fieldName}"]`);
            if (field) {
                field.classList.remove('error');
                field.style.borderColor = '';
            }
            return true;
        }
    }

    // Método para validar referencia catastral específicamente
    validateReferenciaCatastral(rc) {
        if (!rc || rc.trim() === '') {
            return { valid: true, message: '' }; // Es opcional
        }

        const cleanRC = rc.trim().toUpperCase();
        
        // Patrón básico para referencia catastral española
        // Formato: 14 dígitos + 2 letras + 4 dígitos + 1 letra + 4 dígitos
        const pattern = /^[0-9]{14}[A-Z]{2}[0-9]{4}[A-Z][0-9]{4}$/;
        
        if (!pattern.test(cleanRC)) {
            return {
                valid: false,
                message: 'La referencia catastral no tiene un formato válido'
            };
        }

        return { valid: true, message: '' };
    }
}

class AddressValidator {
    constructor() {
        this.apiClient = window.TasacionesApiClient ? new TasacionesApiClient() : null;
    }

    async validateAddress(address) {
        const errors = [];

        if (!address.provincia || address.provincia.trim() === '') {
            errors.push('La provincia es requerida');
        }

        if (!address.municipio || address.municipio.trim() === '') {
            errors.push('El municipio es requerido');
        }

        if (!address.tipo_via || address.tipo_via.trim() === '') {
            errors.push('El tipo de vía es requerido');
        }

        if (!address.nombre_via || address.nombre_via.trim() === '') {
            errors.push('El nombre de la vía es requerido');
        }

        if (!address.numero || address.numero.trim() === '') {
            errors.push('El número es requerido');
        }

        if (address.codigo_postal && !/^\d{5}$/.test(address.codigo_postal)) {
            errors.push('El código postal debe tener 5 dígitos');
        }

        return {
            valid: errors.length === 0,
            errors: errors
        };
    }
}

// Hacer las clases disponibles globalmente
window.FormValidator = FormValidator;
window.AddressValidator = AddressValidator;